import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { Fragment } from 'react';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import styled from 'styled-components';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var measure2Css = function (value) {
  return value ? typeof value === 'string' ? value : "".concat(value, "px") : undefined;
};
var extractStyles = function (_ref) {
  var width = _ref.width,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      height = _ref.height,
      maxHeight = _ref.maxHeight,
      minHeight = _ref.minHeight,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["width", "maxWidth", "minWidth", "height", "maxHeight", "minHeight", "style"]);

  return _objectSpread({
    style: _objectSpread({
      width: measure2Css(width),
      maxWidth: measure2Css(maxWidth),
      minWidth: measure2Css(minWidth),
      height: measure2Css(height),
      maxHeight: measure2Css(maxHeight),
      minHeight: measure2Css(minHeight)
    }, style)
  }, rest);
};

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function () {
    return data;
  };

  return data;
}
var CircleWrapper = styled.div(_templateObject());

var Circle = function (_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(CircleWrapper, _extends({
    className: "s-circ s-loader ".concat(className || '')
  }, extractStyles(rest)));
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function () {
    return data;
  };

  return data;
}
var RectangleWrapper = styled.div(_templateObject$1());

var Rectangle = function (_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(RectangleWrapper, _extends({
    className: "s-rect s-loader ".concat(className || '')
  }, extractStyles(rest)));
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  .s-loader {\n    position: relative;\n    overflow: hidden;\n    background-color: rgba(0, 0, 0, 0.055);\n\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(\n        90deg,\n        rgba(0, 0, 0, 0),\n        rgba(0, 0, 0, 0.07),\n        rgba(0, 0, 0, 0)\n      );\n      transform: translateX(-100%);\n    }\n  }\n\n  &.s-active {\n    .s-loader {\n      &:after {\n        animation: loading 1.75s 0.5s infinite;\n      }\n    }\n  }\n\n  &.s-inactive {\n    .s-loader {\n      &:after {\n        animation: none;\n      }\n    }\n  }\n\n  &.s-dark {\n    .s-loader {\n      background-color: rgba(255, 255, 255, 0.175);\n      &:after {\n        background: linear-gradient(\n          90deg,\n          rgba(255, 255, 255, 0),\n          rgba(255, 255, 255, 0.12),\n          rgba(255, 255, 255, 0)\n        );\n      }\n    }\n  }\n\n  @keyframes loading {\n    100% {\n      transform: translateX(100%);\n    }\n  }\n\n  .s-rect {\n    border-radius: 2px;\n  }\n  .s-circ {\n    border-radius: 50%;\n  }\n"]);

  _templateObject$2 = function () {
    return data;
  };

  return data;
}
var SkeletonWrapper = styled.div(_templateObject$2());

var Skeleton = function (_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? true : _ref$active,
      darkTheme = _ref.darkTheme,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["active", "darkTheme", "className"]);

  return /*#__PURE__*/React.createElement(SkeletonWrapper, _extends({
    className: "skeleton ".concat(className || '').concat(active ? ' s-active' : ' s-inactive').concat(darkTheme ? ' s-dark' : '')
  }, rest));
};

Skeleton.displayName = 'Skeleton';
Skeleton.Rectangle = Rectangle;
Skeleton.Circle = Circle;

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  .s-header {\n    height: 2rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .s-line {\n    height: 1.25rem;\n    margin-bottom: 0.75rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"]);

  _templateObject$3 = function () {
    return data;
  };

  return data;
}
var Wrapper = styled.div(_templateObject$3());

var Paragraph = function (_ref) {
  var header = _ref.header,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 3 : _ref$lines,
      _ref$widths = _ref.widths,
      widths = _ref$widths === void 0 ? ['100%', '100%', '75%', '35%', '50%', '85%'] : _ref$widths,
      skeletonProps = _ref.skeletonProps,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["header", "lines", "widths", "skeletonProps", "className", "children"]);

  var max = widths.length || 0;
  return /*#__PURE__*/React.createElement(Skeleton, skeletonProps, /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: "s-paragraph ".concat(className || '')
  }, rest), header && /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
    className: "s-header",
    width: "50%"
  }), lines > 0 ? _toConsumableArray(Array(lines)).map(function (_, i) {
    return /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
      key: i,
      className: "s-line",
      width: widths[i % max] || '100%'
    });
  }) : null, children));
};
Paragraph.displayName = 'Paragraph';

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  border: solid 1px rgba(0, 0, 0, 0.08);\n  border-radius: 3px;\n  padding: 1.25rem;\n\n  .s-image {\n    margin-bottom: 1rem;\n  }\n"]);

  _templateObject$4 = function () {
    return data;
  };

  return data;
}
var Wrapper$1 = styled.div(_templateObject$4());

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Card = function (_ref) {
  var width = _ref.width,
      maxWidth = _ref.maxWidth,
      image = _ref.image,
      header = _ref.header,
      paragraph = _ref.paragraph,
      skeletonProps = _ref.skeletonProps,
      className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["width", "maxWidth", "image", "header", "paragraph", "skeletonProps", "className", "children", "style"]);

  return /*#__PURE__*/React.createElement(Skeleton, skeletonProps, /*#__PURE__*/React.createElement(Wrapper$1, _extends({
    className: "s-card ".concat(className || ''),
    style: _objectSpread$1({
      width: measure2Css(width),
      maxWidth: measure2Css(maxWidth)
    }, style)
  }, rest), image ? /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
    className: "s-image",
    height: 200
  }) : null, header || paragraph ? /*#__PURE__*/React.createElement(Paragraph, {
    header: header,
    lines: paragraph ? 3 : 0,
    skeletonProps: skeletonProps
  }) : null, children));
};

Card.displayName = 'Card';

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n\n  > * {\n    display: table-cell;\n\n    &:first-of-type {\n      padding-right: 1.5rem;\n      vertical-align: top;\n    }\n\n    &:last-of-type {\n      width: 100%;\n      vertical-align: middle;\n    }\n  }\n"]);

  _templateObject$5 = function () {
    return data;
  };

  return data;
}
var Wrapper$2 = styled.div(_templateObject$5());

var Comment = function (_ref) {
  var _ref$avatarSize = _ref.avatarSize,
      avatarSize = _ref$avatarSize === void 0 ? 45 : _ref$avatarSize,
      _ref$avatarCircle = _ref.avatarCircle,
      avatarCircle = _ref$avatarCircle === void 0 ? true : _ref$avatarCircle,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 3 : _ref$lines,
      skeletonProps = _ref.skeletonProps,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["avatarSize", "avatarCircle", "lines", "skeletonProps", "className", "children"]);

  return /*#__PURE__*/React.createElement(Skeleton, skeletonProps, /*#__PURE__*/React.createElement(Wrapper$2, _extends({
    className: "s-comment ".concat(className || '')
  }, rest), /*#__PURE__*/React.createElement("div", null, avatarCircle ? /*#__PURE__*/React.createElement(Skeleton.Circle, {
    className: "s-avatar",
    width: avatarSize,
    height: avatarSize
  }) : /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
    className: "s-avatar",
    width: avatarSize,
    height: avatarSize
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paragraph, {
    header: false,
    lines: lines
  }), children)));
};
Comment.displayName = 'Comment';

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  .s-label {\n    height: 1rem;\n    max-width: 150px;\n    margin-bottom: 0.3rem;\n  }\n  .s-input {\n    height: 2.5rem;\n    margin-bottom: 1.2rem;\n  }\n  .s-button {\n    height: 2.5rem;\n    max-width: 175px;\n  }\n"]);

  _templateObject$6 = function () {
    return data;
  };

  return data;
}
var Wrapper$3 = styled.div(_templateObject$6());

var Form = function (_ref) {
  var _ref$inputs = _ref.inputs,
      inputs = _ref$inputs === void 0 ? 3 : _ref$inputs,
      inputHeight = _ref.inputHeight,
      _ref$button = _ref.button,
      button = _ref$button === void 0 ? true : _ref$button,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? true : _ref$label,
      _ref$widths = _ref.widths,
      widths = _ref$widths === void 0 ? ['100%'] : _ref$widths,
      skeletonProps = _ref.skeletonProps,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["inputs", "inputHeight", "button", "label", "widths", "skeletonProps", "className", "children"]);

  var max = widths.length || 0;
  var style = inputHeight ? {
    height: measure2Css(inputHeight)
  } : undefined;
  return /*#__PURE__*/React.createElement(Skeleton, skeletonProps, /*#__PURE__*/React.createElement(Wrapper$3, _extends({
    className: "s-form ".concat(className || '')
  }, rest), _toConsumableArray(Array(inputs)).map(function (_, i) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: i
    }, label ? /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
      className: "s-label"
    }) : null, /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
      key: i,
      className: "s-input",
      width: widths[i % max] || '100%',
      style: style
    }));
  }), button ? /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
    className: "s-button",
    style: style
  }) : null, children));
};
Form.displayName = 'Form';

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: -1rem;\n  overflow: hidden;\n\n  > * {\n    flex: 1 1 auto;\n    padding: 1rem;\n  }\n"]);

  _templateObject$7 = function () {
    return data;
  };

  return data;
}
var Wrapper$4 = styled.div(_templateObject$7());

var isRenderPropFunction = function (value) {
  return typeof value === 'function';
};

var Grid = function (_ref) {
  var _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 3 : _ref$cols,
      skeletonProps = _ref.skeletonProps,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["cols", "skeletonProps", "className", "children"]);

  return /*#__PURE__*/React.createElement(Skeleton, skeletonProps, /*#__PURE__*/React.createElement(Wrapper$4, _extends({
    className: "s-grid ".concat(className || '')
  }, rest), cols > 0 ? _toConsumableArray(Array(cols)).map(function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i
    }, isRenderPropFunction(children) ? children(i) : children);
  }) : null));
};
Grid.displayName = 'Grid';

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  border-collapse: collapse;\n\n  th,\n  td {\n    padding: 0.8rem;\n    border-bottom: solid 1px rgba(0, 0, 0, 0.1);\n  }\n\n  th {\n    .s-cell {\n      display: flex;\n      height: 2rem;\n    }\n  }\n\n  td {\n    .s-cell {\n      display: flex;\n      height: 1.25rem;\n    }\n  }\n"]);

  _templateObject$8 = function () {
    return data;
  };

  return data;
}
var Wrapper$5 = styled.table(_templateObject$8());

var Table = function (_ref) {
  var _ref$head = _ref.head,
      head = _ref$head === void 0 ? true : _ref$head,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 3 : _ref$rows,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 4 : _ref$cols,
      _ref$widths = _ref.widths,
      widths = _ref$widths === void 0 ? ['100%', '100%', '75%', '35%', '50%', '85%'] : _ref$widths,
      skeletonProps = _ref.skeletonProps,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["head", "rows", "cols", "widths", "skeletonProps", "className", "children"]);

  var rowIter = Array(rows).fill(0);
  var colIter = Array.isArray(cols) ? cols : Array(cols).fill(0);
  var max = widths.length;
  var td = colIter.map(function (_, j) {
    return /*#__PURE__*/React.createElement("td", {
      key: "c-".concat(j),
      style: {
        width: widths[j % max]
      }
    }, /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
      as: "span",
      width: "100%",
      className: "s-cell"
    }));
  });
  return /*#__PURE__*/React.createElement(Skeleton, skeletonProps, /*#__PURE__*/React.createElement(Wrapper$5, _extends({
    className: "s-table ".concat(className || '')
  }, rest), head ? /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, colIter.map(function (val, i) {
    return /*#__PURE__*/React.createElement("th", {
      key: i,
      align: "left"
    }, val ? val : /*#__PURE__*/React.createElement(Skeleton.Rectangle, {
      as: "span",
      width: "100%",
      className: "s-cell"
    }));
  }))) : null, /*#__PURE__*/React.createElement("tbody", null, rowIter.map(function (_, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, td);
  }), children)));
};
Table.displayName = 'Table';

export default Skeleton;
export { Card, Comment, Form, Grid, Paragraph, Table };
